import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL, API_KEY } from 'constant/apiConstant';

export const forgotPasswordApi = createApi({
  reducerPath: 'forgotPasswordApi',
  tagTypes: ['Post'],
  baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URL }),
  endpoints: (builder) => ({
    postForgotPassword: builder.mutation({
      query: (payload) => ({
        url: '/user/forgot-password',
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-API-KEY': API_KEY
        }
      }),
      invalidatesTags: ['Post']
    })
  })
});

export const { usePostForgotPasswordMutation } = forgotPasswordApi;
